export { default as ProveedoresList } from './Listar'
export { default as CrearProveedor } from './Crear'
